import { render } from "./toDoModal.vue?vue&type=template&id=2b9bbb34&scoped=true"
import script from "./toDoModal.vue?vue&type=script&lang=js"
export * from "./toDoModal.vue?vue&type=script&lang=js"

import "./toDoModal.vue?vue&type=style&index=0&id=2b9bbb34&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9bbb34"]])

export default __exports__